// MODULES
import React from "react";

export default function HiddenDefaultFields({ fields }) {
    return (
        <div className="Cob-HiddenDefaultFields" style={{ display: "none" }}>
            { fields.map(field => ( 
                <input key={ field.name } type="hidden" name={ field.name } value={ field.value } />
            ))}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/HiddenDefaultFields/HiddenDefaultFields.js